import { useQuery } from '@apollo/client';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import getCountryByCode from 'common/countries/getCountryByCode';
import useCurrentLanguage from 'common/hooks/useCurrentLanguage';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import ComplianceApplicationProblem from '../../components/ComplianceApplicationProblem/ComplianceApplicationProblem';
import { ComplianceApplicationProblemReason } from '../../libs/constants';
import { TaxResidencyCountryNotAllowedDocument } from './graphql/TaxResidencyCountryNotAllowed.gql';
import locales from './locales';

/**
 * A blocker page explaining to the user that we cannot open an account for them
 * due to their country of tax residency not being allowed.
 */
const TaxResidencyCountryNotAllowed = asBentoPage(({ Layout }) => {
  const translationLanguage = useCurrentLanguage();
  const { data } = useQuery(TaxResidencyCountryNotAllowedDocument);

  const countryCode = data?.viewer.taxResidency?.country;
  const localizedCountryName =
    countryCode &&
    getCountryByCode({
      countryCode,
      translationLanguage,
    })?.label;

  return (
    <Layout data-testid="compliance-error" nav={<OBNavigation />}>
      <ComplianceApplicationProblem
        reason={ComplianceApplicationProblemReason.TaxResidencyCountry}
        reasonText={
          localizedCountryName
            ? (locales.formatString(locales.reason, {
                country: localizedCountryName,
              }) as string)
            : locales.reasonWithMissingCountry
        }
      />
    </Layout>
  );
});

export default TaxResidencyCountryNotAllowed;
